import React from 'react'
import { Redirect, withRouter } from 'react-router-dom'

import Context from './Context'
import firebase from '../../firebase/firebase'
import * as routes from '../../constants/routes'

const withAuthorization = (condition = () => true) => (Component) => {
  class WithAuthorization extends React.Component {
    componentDidMount () {
      firebase.auth().onAuthStateChanged(user =>
        !user ? this.props.history.push(routes.LOGIN) : null
      )
    }

    render () {
      const {history, ...others} = this.props
      return (
        <Context.Consumer>
          {user => {
            if (user.token) {
              if (history.location.pathname.includes(routes.LOGIN)) {
                return <Redirect to='/' />
              }
            }
            return user && condition(user)
              ? <Component {...user} {...others} />
              : null
          }}
        </Context.Consumer>
      )
    }
  }

  return withRouter(WithAuthorization)
}

export default withAuthorization


// WEBPACK FOOTER //
// ./src/components/Users/withAuthorization.js